import { Box, Text } from '@fullstory/components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Arrow } from './Arrow';

type Alignment = 'center' | 'left' | 'right';
export interface PaginationProps {
  alignment: Alignment;
  start: number | BigInt;
  end: number | BigInt;
  total: number | BigInt;
  page: number;
  disableNext: boolean;
  disablePrev: boolean;
  onClickNext?: () => void;
  onClickPrev?: () => void;
  testId?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  alignment,
  start,
  end,
  page,
  total,
  onClickNext,
  onClickPrev,
  disableNext,
  disablePrev,
  testId,
}) => {
  if (alignment === 'center') {
    return (
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width={144}
        testId={testId}
      >
        <Arrow page={page} disabled={disablePrev} icon="previous" onClick={onClickPrev} />
        <Label total={total} start={start} end={end} />
        <Arrow page={page} disabled={disableNext} icon="next" onClick={onClickNext} />
      </Box>
    );
  } else if (alignment === 'left') {
    return (
      <Box display="flex" alignItems="center" gap={12} testId={testId}>
        <Label total={total} start={start} end={end} />
        <Arrow page={page} disabled={disablePrev} icon="previous" onClick={onClickPrev} />
        <Arrow page={page} disabled={disableNext} icon="next" onClick={onClickNext} />
      </Box>
    );
  }

  return (
    <Box data-component="Pagination" display="flex" alignItems="center" gap={12} testId={testId}>
      <Arrow page={page} disabled={disablePrev} icon="previous" onClick={onClickPrev} />
      <Arrow page={page} disabled={disableNext} icon="next" onClick={onClickNext} />
      <Label total={total} start={start} end={end} />
    </Box>
  );
};

interface LabelProps {
  total: number | BigInt;
  start: number | BigInt;
  end: number | BigInt;
}

const Label: React.FC<LabelProps> = ({ total, start, end }) => (
  <Text data-component="Label" appearance="bodySmall">
    <FormattedMessage
      defaultMessage="{end, select, 0 {0} other {{start, number}-{end, number}}} of {total, number}"
      description="Pager controls specifying how many items are displayed on a page."
      id="abyQzH"
      values={{
        total: total.toString(),
        start: start.toString(),
        end: end.toString(),
      }}
    />
  </Text>
);

export { Pagination };
